import styled from '@emotion/styled';
import React from 'react';
import { NullableOptionValue, OptionValue } from '../types';
import { HighDropdown } from './HighDropdown';

interface OptionDropdownProps {
	onChange: (value: NullableOptionValue) => void;
	options: readonly OptionValue[];
	optionKey: string;
	disabled?: boolean;
	selectedValue: string | number | boolean | null;
}

const NarrowHighDropdown = styled(HighDropdown)`
	&.ui.selection.dropdown {
		padding-top: 8px;
		padding-bottom: 8px;
		min-height: 30px;
		max-height: 30px;
		height: 30px;
		font-size: 13px;
	}

	&.ui.search.dropdown > input.search,
	&.ui.selection.dropdown > .dropdown.icon {
		min-height: 28px;
		max-height: 28px;
		height: 28px;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	&.ui.selection.dropdown > .dropdown.icon {
		padding-top: 8px;
	 }

	 &.ui.selection.dropdown .menu>.item {
		padding: 8px 16px !important;
		min-height: 30px;
		max-height: 30px;
		height: 30px;
		font-size: 13px;
	 }

`;

export const OptionDropdown: React.FC<OptionDropdownProps> = ({
	onChange,
	options,
	optionKey,
	disabled,
	selectedValue
}) => (
	<NarrowHighDropdown
		disabled={disabled}
		onChange={(_, { value }) => {
			onChange(value === '' ? null : (value as OptionValue));
		} }
		placeholder={optionKey}
		options={options.map((option) => ({
			text: option.toString(),
			value: option,
			active: selectedValue === option
		}))}
		{...(selectedValue && { defaultValue: selectedValue.toString() })}
		selection
		search
		clearable />
);
